import { render, staticRenderFns } from "./ArchiveTransactionDetail.vue?vue&type=template&id=774d689e"
import script from "./ArchiveTransactionDetail.vue?vue&type=script&lang=ts"
export * from "./ArchiveTransactionDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports